import { useUserRole } from "../utils/hooks/useUserRole";
import Dashboard from "../components/Dashboard";
import DashboardHo from "../components/Dashboard/Ho";

export default function HomePage() {
  const { isHeadOfficeAccounting } = useUserRole();
  return isHeadOfficeAccounting ? <DashboardHo /> : <Dashboard />;
}
